<template>
    <v-alert
        density="compact"
        theme="dark"
        color="grey-darken-2"
        class="add-service-snackbar cursor-pointer mb-0 rounded-0 sticky-bar w-100"
    >
        <template v-slot:prepend>
            <v-icon>mdi-account-search</v-icon>
            <span class="ms-2" v-text="snackbarText" />
        </template>
        <template v-slot:close>
            <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{props}">
                    <v-btn color="white" icon="mdi-close" variant="text" class="close-btn" v-bind="props" />
                </template>

                <v-card>
                    <v-card-title>
                        {{ `${$t('close')} ${$t('choose.agent_dialog_header').toLowerCase()}?` }}
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn variant="flat" color="primary" @click="close"> ok </v-btn>
                        <v-btn variant="flat" @click="dialog = false">
                            {{ $t('cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-alert>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {AgentSearchSnackbar} from '@/components/snippets/AgentSearchSnackbar.vue'

    @Component
    export class PrivateClientSearchSnackbar extends AgentSearchSnackbar {
        get selectedPrivateClient() {
            return persistentStore.selectedPrivateClient
        }

        get snackbarText() {
            if (!this.selectedPrivateClient) {
                return null
            }
            return `${this.$t('search')} ${this.$t('and')} ${this.$t('booking')} ${this.$t('to_room')} ${
                this.selectedPrivateClient.firstName || ''
            }  ${this.selectedPrivateClient.lastName || ''}`
        }

        clear() {
            persistentStore.SET_SELECTED_PRIVATE_CLIENT(null)
        }
    }

    export default PrivateClientSearchSnackbar
</script>
